
import { defineComponent, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import StoreUtil from '@/stores/StoreUtil'

export default defineComponent({
  name: 'ErrorPage',
  setup() {
    const { t } = useI18n()
    const ErrorStore = StoreUtil.useStore('ErrorStore')
    onMounted(async () => {
      console.warn()
    })
    return {
      t,
      title: ErrorStore.title,
      message: ErrorStore.message,
      descriptions: ErrorStore.descriptions,
    }
  },
  components: {},
})
